export default "__VITE_ASSET__D2mQ4D43__"